import watchAttachNotes from './attachNotes'
import watchAttachTranscript from './attachTranscript'
import watchDetachNotes from './detachNotes'
import watchDetachTranscript from './detachTranscript'
import watchStartDiscoveryRun from './startDiscoveryRun'

export const discoveryRunsSagas = [
  watchAttachTranscript,
  watchAttachNotes,
  watchDetachTranscript,
  watchDetachNotes,
  watchStartDiscoveryRun,
]
